export default __webpack_public_path__ + "static/media/hero.c5fbbec6.svg";